module.exports = __webpack_public_path__ + "img/yidaiyilu@3x.91706afc.png";